module.exports = __webpack_public_path__ + "img/trunk_1x3_z18.62813250.svg";